exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".due-to-reports-modal .container .jq-checkbox{display:inline-block;width:15px;height:15px;background:#fff;border-radius:2px;border:1px solid #979797}.due-to-reports-modal .container .jq-checkbox.checked{background:#3ec19d;border:1px solid #3ec19d}.due-to-reports-modal .container .jq-checkbox.checked:after{content:\"\";width:5px;height:12px;color:#fff;display:block;position:absolute;top:0;left:4px;border:2px solid #fff;border-left:none!important;border-top:none!important;transform:rotate(35deg)}@media (min-width:768px){.due-to-reports-modal .modal-dialog{overflow:auto;width:580px;height:836px}}@media (max-width:768px){.due-to-reports-modal .modal-dialog{position:absolute;width:100vw;height:100vh;margin:0}.due-to-reports-modal .modal-dialog .modal-content{border:none;box-shadow:none}.due-to-reports-modal .modal-dialog .modal-content a.other-reason,.due-to-reports-modal .modal-dialog .modal-content input.accept-send-mail{font-size:16px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!./directives/acceptRejectApplication/rejectApplication/dueToReportsModal/dueToReportsModal.css
// module id = 495
// module chunks = 0